const subitisingImages = {
  apple: {
    imgName: 'Apple',
    uri: require('../../assets/images/apple.png')
  },
  bird: {
    imgName: 'Bird',
    uri: require('../../assets/images/bird.png')
  },
  chick: {
    imgName: 'Chick1',
    uri: require('../../assets/images/chick1.png')
  },
  flower: {
    imgName: 'Flower',
    uri: require('../../assets/images/flower.png')
  },
  football: {
    imgName: 'Football',
    uri: require('../../assets/images/football.png')
  },
  hat: {
    imgName: 'Hat',
    uri: require('../../assets/images/hat.png')
  },
  icecream: {
    imgName: 'IceCream',
    uri: require('../../assets/images/icecream.png')
  },

  strawberry: {
    imgName: 'Strawberry1',
    uri: require('../../assets/images/strawberry1.png')
  },

};

export const subitisingImageChoices = [
  'apple', 'bird', 'chick', 'flower', 'hat', 'football', 'strawberry'
];

export { subitisingImages };
